import apiFetch from '../apiFetch'

export default function (token, data, fleetId) {
  return apiFetch({ endPoint: `UnattendedProcess/SetOperateDataOtherDataFleet/${fleetId}`, method: 'POST', body: data, token: token })
}
